import { PortalAccessProvider } from '../../components/PortalAccess';

export default function SmmGuard({ children }) {
  return <PortalAccessProvider standalone>{children}</PortalAccessProvider>;
}
